<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hupZyf/tc-custom/9781460393529.jpg?1701861770213" alt="This image is the cover for the book Long, Tall Texan Legacy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Long, Tall Texan Legacy
      </h1>
      <p class="bookDescription body article font2">
        <i>New York Times</i> bestselling author Diana Palmer delivers two reader-favorite tales of cowboys on the range!THE FOUNDING FATHERDiscover how legends were made when Jacobsville founding father Big John Jacobs weds the daughter of a prosperous railroad tycoon. Will passion blaze when the fortune-seeking Long, Tall Texan brands his sweetly unassuming wife with his soul-searing kisses?JUSTINJustin Ballenger was jilted by Shelby Jacobs, privileged daughter of the Jacobsville fortune, for a wealthy playboy. After six resentful years, Shelby returned, penniless and alone. It was Justin's turn to sneer, but honor wouldn't allow it. He was sure he could never trust her again, but that old flame burned hotter than a three-alarm brush fire-and Shelby had a secret that only fanned the flames.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diana Palmer
      </h2>
      
      <p class="authorDescription body article">The prolific author of more than one hundred books, Diana Palmer got her start as a newspaper reporter. A New York Times bestselling author and voted one of the top ten romance writers in America, she has a gift for telling the most sensual tales with charm and humor. Diana lives with her family in Cornelia, Georgia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cb3c429c